import { NzSafeAny } from 'ng-zorro-antd/core/types';

export function groupBy(array: NzSafeAny[], _key: string): { [key: string]: NzSafeAny[] } {
  const groups: { [key: string]: NzSafeAny[] } = {};
  array.forEach(item => {
    const group = JSON.stringify(item[_key]);
    groups[group] = groups[group] || [];
    groups[group].push(item);
  });
  return groups;
}
